import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pager({ skip, limit, total, onPrev, onNext }) {
  const from = total === 0 ? 0 : skip + 1;
  const to = Math.min(skip + limit, total);
  return (
    <div className="flex items-center gap-2" data-testid="pager">
      <span className="text-xs text-gray-500">{from}–{to} of {total}</span>
      <Button size="sm" variant="outline" className="h-8" disabled={skip === 0} onClick={onPrev} data-testid="pager-prev"><ChevronLeft className="h-4 w-4" /></Button>
      <Button size="sm" variant="outline" className="h-8" disabled={skip + limit >= total} onClick={onNext} data-testid="pager-next"><ChevronRight className="h-4 w-4" /></Button>
    </div>
  );
}
